let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cpGbr")).then(() => parcelRequire('7r7le'));